module.exports = __webpack_public_path__ + "img/chevron-forward-gray.955606a0.svg";